import React, { useEffect, useState, useContext } from 'react';
import axios from '../../config/axios';

import UsersContext from '../../contexts/usersContext';
import AuthContext from '../../contexts/AuthContext';

import Spinner from '../../components/UI/Spinner/Spinner';
import Person from './Person/Person';
import Section from './Section/Section';

import classes from './AboutBox.module.scss';

const AboutBox = props => {
    const Users = useContext(UsersContext)[0];
    const auth = useContext(AuthContext)[0];

    const [show, setShow] = useState(false);
    const [filterKey, setFilterKey] = useState('');
    const [state, setState] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setShow(props.active === props.type)
    }, [props.active])

    useEffect(() => {
        setLoading(true);
        let option = '';
        let optionSource = '';
        let optionKey = '';
        switch (props.type) {
            case 'plenary':
                option = 'Plenary speaker';
                optionKey = 'participation';
                optionSource = `/participations.json?auth=${auth.token}`;
                break;
            case 'scientific':
                option = 'scientific';
                optionKey = 'role';
                optionSource = `organizer-roles.json?auth=${auth.token}`;
                break;
            case 'organizer':
                option = 'organizer';
                optionKey = 'role';
                optionSource = `organizer-roles.json?auth=${auth.token}`;
                break;
            default:
                option = '';
                optionKey = '';
                optionSource = '';
        }

        if (props.type !== 'section') {
            axios.get(optionSource)
                .then(result => {
                    const filKey = Object.keys(result.data).find(key => result.data[key][optionKey] === option);
                    setFilterKey(filKey)

                    const userType = props.type === 'plenary' ? Users.participants : Users.organizers;
                    const updatedUsers = Object.keys(userType)
                        .map(key => ({
                            key: key,
                            data: userType[key]
                        }))
                        .filter(el => {
                            return el.data[optionKey] === filKey
                        })
                    setState(updatedUsers);
                    setLoading(false)
                })
        } else {
            axios.get(`/sections.json?auth=${auth.token}`)
                .then(result => {
                    setState(result.data);
                    setLoading(false);
                })
        }
    }, [])

    useEffect(() => {
        return () => {
            setLoading(false);
        }
    }, [])

    let title = '';
    switch (props.type) {
        case 'plenary':
            title = 'Plenary speakers';
            break;
        case 'scientific':
            title = 'Scientific Committee';
            break;
        case 'organizer':
            title = 'Organizers';
            break;
        case 'section':
            title = 'Thematic sections';
            break;
        default:
            title = '';
    }

    const toggleShowHandler = () => {
        setShow(!show);
        props.onSelect(props.type);
    }

    let content = null;
    if (state) {
        switch (props.type) {
            case 'plenary':
                content = Object.keys(state)
                    .map(key => {
                        return {
                            id: key,
                            data: state[key].data
                        }
                    })
                    .sort((el1, el2) => {
                        if (el1.data.lastName < el2.data.lastName) {
                            return -1;
                        } else {
                            return 1;
                        }
                    })
                    .map(el => {
                        return <Person
                            key={el.id}
                            firstName={el.data.firstName}
                            lastName={el.data.lastName}
                            affiliation={el.data.affiliation}
                            title={el.data.title}
                            info={el.data.infoText}
                            abstract={el.data.abstract} />
                    })
                break;
            case 'scientific':
                content = Object.keys(state)
                    .map(key => {
                        return <Person
                            key={state[key].key}
                            firstName={state[key].data.firstName}
                            lastName={state[key].data.lastName}
                            affiliation={state[key].data.affiliation} />
                    })
                break;
            case 'organizer':
                content = Object.keys(state)
                    .map(key => {
                        return <Person
                            key={state[key].key}
                            firstName={state[key].data.firstName}
                            lastName={state[key].data.lastName}
                            affiliation={state[key].data.affiliation} />
                    })
                break;
            case 'section':
                content = Object.keys(state)
                    .map(key => {
                        return <Section
                            key={key}
                            name={state[key].section}
                            description={state[key].description}
                            organizer={state[key].organizer} />
                    })
                break;
            default:
                title = '';
        }
    }

    return <div className={classes.AboutBox}>
        <h2 className={props.active === props.type ? classes.TitleActive : classes.Title} onClick={toggleShowHandler}>{title}</h2>
        {!loading
            ? show && content
            : <Spinner />}

    </div>
}

export default AboutBox;